import { render, staticRenderFns } from "./PhysicalTestQuery.vue?vue&type=template&id=62d6e106&scoped=true"
import script from "./PhysicalTestQuery.vue?vue&type=script&lang=js"
export * from "./PhysicalTestQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d6e106",
  null
  
)

export default component.exports